import React from 'react';
import ReactDOM from 'react-dom';
import {
    SubnavigationButton,
    Chip,
    Div,
    FormItem,
    SimpleCell,
    PanelHeaderButton,
    PanelHeader,
    Input,
    SplitLayout,
    SplitCol,
    List,
    Switch,
    Button, ModalPage, ModalPageHeader, ButtonGroup, ModalRoot, Badge, Header
} from '@vkontakte/vkui';
import axios from "axios";
import * as constants from "../assets/constants";
import {Icon12CheckCircle, Icon24Cancel, Icon24Done, Icon24WarningTriangleOutline} from "@vkontakte/icons";
import CartApi from "../api/CartApi";
import {AdaptivityContext, formatQnt} from "../assets/constants";
import BaseComponent from "../components/BaseComponent";
import {current_theme} from "../index";
import AdditionalProducts from "./additionalProducts";
import HelpButton from "../assets/HelpButton";

class Scissors extends BaseComponent {
    state = {
        items: [],
        series: [],
        error_text: '',
        showSeries: false,
        one_seria: false,
        saving: false,
        current_index: null
    }

    constructor(props) {
        super(props);


    }

    componentDidMount() {
        super.componentDidMount()
        this.getItems()
    }

    componentDidUpdate(prevProps: Readonly<P>, prevState: Readonly<S>, snapshot: SS) {

        if (prevProps.showScissorsSeries != this.props.showScissorsSeries) {
            this.setState({showSeries: this.props.showScissorsSeries})
        }
    }

    sortCurrentSeries = (series, setState = true, desc = false) => {

        let old = series


        old.sort(function (a, b) {


            return desc ? b.ost_qnt * 1 - a.ost_qnt * 1 : a.ost_qnt * 1 - b.ost_qnt * 1;

        });

        if (setState) {
            old.map((el, i) => {
                old[i].ost_qnt = (el.ost_qnt * this.props.product.unit.K / this.props.current_unit.K)
            })
            this.setState({series: old})
        }
        return old
    }
    getSortinputsOrder = (orders, desc = false) => {
        let old = orders

        old.sort(function (a, b) {

            return desc ? b.order_qnt * 1 - a.order_qnt * 1 : a.order_qnt * 1 - b.order_qnt * 1

        });

        return old;

    }

    getMaxSeriesScissors = (series, qnt = 0) => {

        let seria = null;
        let max = 0;

        let find = false;
        series.map((el, i) => {


            if (!find && el.ost_qnt * 1 >= max && el.ost_qnt * 1 >= qnt) {
                seria = el;
                max = el.ost_qnt * 1;
                if (qnt > 0) {
                    find = true;
                }
            }

        });

        return seria;
    }


    getItems = () => {
        const body = new FormData()
        body.append('product_id', this.props.product.id)
        body.append('sclad_id', this.props.sclad.sclad_id)
        let sAjaxSource = '/?app=partnersproducts&act=getSeries';

        this.setState({
            series: [], items: []
        });
        axios.post(this.props.base_url + sAjaxSource, body,
            {
                withCredentials: true
            }
        ).then((response) => {
            console.log(response)
            if (response.data.width.value) {
                response.data.width.value = response.data.width.value.toString().replace(",", ".")
            }
            this.setState({width: response.data.width})

            this.sortCurrentSeries(response.data.results)
            setTimeout(() => {
                let numAdd = 0

                CartApi.items.map((el, i) => {
                    if (el.sclad_id === this.props.sclad.sclad_id && el.product_id === this.props.product.id) {
                        numAdd++
                        console.log(el)
                        this.addPiece(el.quantity, el.series_id, el.id, el.additional)
                    }
                })
                if (numAdd == 0) {
                    this.addPiece()
                }
            }, 500)
        })

    }
    addPiece = (qnt = '', series_id = undefined, cart_id = undefined, additionalList = []) => {
        const old = this.state.items;

        let seria = undefined;
        if (series_id != undefined) {
            console.log(series_id)
            seria = this.state.series.find(el => el.ost_id == series_id)
        }
        const additional = []

        if (Array.isArray(additionalList) && additionalList) {
            additionalList.map(
                additionalItem => additional.push(
                    {
                        need_ost: additionalItem.type == "number",
                        qnt: additionalItem.qnt,
                        comment: additionalItem.comment,
                        name: additionalItem.product ? additionalItem.product.name : additionalItem.name,
                        checked: additionalItem.qnt > 0,
                        id: additionalItem.product_id
                    }
                ))
        }
        const new_item = {
            order_qnt: qnt,
            seria: seria,
            cart_id: cart_id,
            uid: constants.getGUID(),
            additionalItems: additional
        }
        old.push(new_item)
        this.setState({items: old})
    }

    setAdditionals = (items) => {


        const olds = this.state.items
        const old = this.state.items[this.state.current_index]
        old.additionalItems = items
        olds[this.state.current_index] = old
        this.setState({items: olds})
        this.setActiveModal(null)
    }

    changeOrder = (e = null, index = null, isM2 = true) => {

        let old = this.state.items;
        let value = ''
        if (e != null) {
            value = e.target.value.replace(',', '.')
            const match = value.match('([0-9]+[\.\,]?([0-9]{1,3})?)')
//        console.log(match)
            if (value !== '') {
                if (!match) return
            }

            let qnt = match ? match[0] : '';
            if (qnt.toString().endsWith('.') || qnt.toString().endsWith(',')) {
                old[index].order_qnt_M = qnt;

                if (isM2) {
                    this.noRenderM2 = true
                } else {
                    this.noRender = true
                    qnt += '0'
                }

            }
            if (!this.noRenderM2) {

                qnt = qnt * 1;
                const width = this.getSafeWidth()
                if (value !== '') {
                    if (!isM2) {

                        qnt = (qnt * width).toFixed(3)

                    }
                } else {
                    qnt = '';
                }
            }
            old[index].order_qnt = qnt;
            if (qnt === '') {
                old[index].seria = undefined
            }
        }
        const _12_2_rule = this.props.current_user.meta.settings._12_2_rule == '1'
        const minLim = 2
        const maxLim = _12_2_rule ? 12 : 6
        if (value !== '') {
            let series = JSON.parse(JSON.stringify(this.state.series));
            let orders = []
            let totalQnt = 0;
            old.map((el, i) => {
                orders.push(el)
            })


            let seriesSort = this.sortCurrentSeries(series, false)
            let ordersSort = this.getSortinputsOrder(orders, true)
            ordersSort.map((el, i) => {
                if (el.order_qnt * 1 > 0 && i < minLim) {
                    totalQnt += el.order_qnt * 1
                }
            })

            const checkRule62 = (orderQnt, stockQnt) => {
                let result = true
                const endStock = stockQnt - orderQnt

                if (endStock < 0 || (endStock >= minLim && endStock <= maxLim)) result = false
                return result
            }
            const findCombinationSeries = (tryOneSeria = false) => {
                series = JSON.parse(JSON.stringify(this.state.series));
                seriesSort = this.sortCurrentSeries(series, false)

                let actualSeria = null
                let actualSeriaIndex = null
                let numFind = 0
                ordersSort.map((order, z) => {
                    let find = false;
                    order.seria = undefined;
                    const maxSeria = this.getMaxSeriesScissors(seriesSort)
                    if (tryOneSeria) {
                        if (z == 1 && actualSeria) {
                            order.seria = actualSeria
                            find = true;
                            numFind++
                            actualSeria.ost_qnt = actualSeria.ost_qnt * 1 - totalQnt

                            seriesSort[actualSeriaIndex] = actualSeria

                            series = JSON.parse(JSON.stringify(seriesSort))
                            seriesSort = this.sortCurrentSeries(series, false)
                            actualSeria = null
                            actualSeriaIndex = null
                            return
                        }

                        if (z == 0) {
                            seriesSort.map((elS, j) => {
                                if (elS.ost_qnt * 1 < totalQnt) return
                                if (!find && checkRule62(totalQnt, elS.ost_qnt * 1)) {

                                    order.seria = elS
                                    actualSeria = elS
                                    actualSeriaIndex = j
                                    //ordersSort.splice(z, 1, order);
                                    find = true
                                    numFind++
                                    //elS.ost_qnt = elS.ost_qnt * 1 - order.order_qnt * 1;
                                    series = JSON.parse(JSON.stringify(seriesSort))
                                    seriesSort = this.sortCurrentSeries(series, false)
                                    // series.splice(j, 1, elS);
                                }
                            });
                        }
                    }
                    if (!find) {
                        seriesSort.map((elS, j) => {

                            if (!find && checkRule62(order.order_qnt * 1, elS.ost_qnt * 1)) {

                                order.seria = elS
                                //ordersSort.splice(z, 1, order);
                                find = true
                                numFind++
                                elS.ost_qnt = elS.ost_qnt * 1 - order.order_qnt * 1;
                                series = JSON.parse(JSON.stringify(seriesSort))
                                seriesSort = this.sortCurrentSeries(series, false)
                                // series.splice(j, 1, elS);
                            }
                        });
                    }
                    if (!find) {
                        console.log('!find!!', maxSeria)
                        order.seria = maxSeria
                    }
                })
                return numFind
            }

            if (!this.state.one_seria) {

                if (findCombinationSeries(true) < 2) {
                    findCombinationSeries(false)
                }

                ordersSort.map((order, z) => {
                    let find = false;
                    old.map((elOld, j) => {
                        if (!find && elOld.uid == order.uid) {
                            find = true
                            old.splice(j, 1, elOld);
                        }
                    });
                })
            } else {
                ordersSort.map((order, z) => {
                    order.seria = undefined;
                })
                let seria = this.getMaxSeriesScissors(seriesSort, totalQnt)
                ordersSort.map((order, z) => {
                    if (order.order_qnt * 1 > 0) {
                        order.seria = seria;
                    }
                })
            }
        }

        this.setState({items: old})

    }

    addOrEditToCart = (noCheckOst = false) => {

        let i
        let len = this.state.items.length
        let textError = []
        const seriesErr = {}
        for (i = 0; i < len; i++) {
            const item = this.state.items[i];

            if (item.order_qnt != undefined && item.order_qnt * 1 > 0) {
                const ost = this.getOstQnt(item)
                const qnt = this.getSeriaQnt(item)
                const ostFinal = ost - item.order_qnt
                const ostTotalFinal = ost - qnt

                const _12_2_rule = this.props.current_user.meta.settings._12_2_rule == '1'
                const minLim = 2
                const maxLim = _12_2_rule ? 12 : 6

                if (!noCheckOst) {
                    if (ost < item.order_qnt) {
                        textError.push(
                            <Div className={current_theme == "dark" ? "yellow" : "red"}
                                 style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                <Div><Icon24WarningTriangleOutline width={48} height={48}/></Div>
                                <span>{`Отрез ${i + 1}: Превышен максимальный отрез ` + formatQnt((ost) / this.getSafeWidth()) + ' пог.м! Не хватает: ' + formatQnt((ostFinal) / this.getSafeWidth()) + ' пог.м'}
                            </span>
                            </Div>
                        )
                    } else {
                        console.log({seria: item, ostTotalFinal: ostTotalFinal, ost: ost, qnt: qnt})
                        if (ostTotalFinal < maxLim && ostTotalFinal > minLim && !seriesErr[item.ost_id]) {
                            textError.push(
                                <Div className={current_theme == "dark" ? "yellow" : "red"}
                                     style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                    <Div><Icon24WarningTriangleOutline width={48} height={48}/></Div>
                                    <span>{`Нарушено правило ${maxLim}/${minLim} отреза линолеума компании Монарх`}
                                        <HelpButton title={<span>Подробно...</span>} showPopup={true} btnSize="l"
                                                    mode="outline" strethed
                                                    text={<span>Серия <b>{item.seria.code}</b>:
                                                    Ваш заказ был {formatQnt(qnt)}м2. От рулона останется {formatQnt(ostTotalFinal)}м2.
                                                    По правилу {maxLim}/{minLim} компании Монарх после отреза от рулона <b>не должно оставаться от {maxLim}м2 до {minLim}м2</b>. <b>Такие куски не ликвидны.</b>
                                                    Подходящего куска сейчас нет - с Вам свяжется менеджер</span>}
                                        /></span>
                                </Div>
                            )
                            seriesErr[item.ost_id] = 1
                        }
                    }
                }

            }
        }
        //sErrors = !item.seria;

        if (textError.length == 0) {
            for (i = 0; i < len; i++) {
                const item = this.state.items[i];

                if (item.order_qnt != undefined && item.order_qnt * 1 > 0) {
                    const ost = this.getOstQnt(item)
                    const qnt = this.getSeriaQnt(item)
                    const ostFinal = ost - item.order_qnt
                    const ostTotalFinal = ost - qnt

                    const _12_2_rule = this.props.current_user.meta.settings._12_2_rule == '1'
                    const minLim = 2
                    const maxLim = _12_2_rule ? 12 : 6
                    item.id = undefined
                    item.sclad_id = this.props.sclad.sclad_id;
                    if (ostTotalFinal < maxLim && ostTotalFinal > 2) {
                        item.sclad_id = -1;
                    }
                    item.series_id = item.seria.ost_id;
                    item.series_code = item.seria.code;
                    item.meta_id = this.props.product.id;
                    item.product_id = this.props.product.id;
                    item.name = this.props.product.name;


                    item.product = this.props.product

                    item.unit_id = this.props.current_unit.external_id
                    item.unit_name = this.props.current_unit.title
                    item.unit = this.props.current_unit

                    item.quantity = (item.order_qnt * 1).toFixed(3).toString().replace('.000', '')
                    if (this.props.sclad.unit_price) {
                        item.price = ((this.props.sclad.is_manual ? this.props.sclad.manual_price : this.props.sclad.base_price) * this.props.current_unit.K / this.props.sclad.unit_price.K).toFixed(2).toString().replace('.00', '')
                    } else {
                        item.price = 0.0;
                    }

                    if (item.cart_id != undefined) {
                        item.id = item.cart_id

                        item.sclad_name = this.props.sclad.sclad_name
                        item.sclad_id = this.props.sclad.sclad_id
                        item.sclad_external_id = this.props.sclad.sclad_external_id
                        if (ostTotalFinal < maxLim && ostTotalFinal > 2 && !seriesErr[item.ost_id]) {
                            item.sclad_name = 'Под заказ'
                            item.sclad_id = -1
                            item.sclad_external_id = '-1'
                        }
                        item.num_ser = this.props.sclad.num_ser
                        item.product_is_rip = this.props.sclad.product_is_rip
                        item.is_rip = this.props.sclad.is_rip
                    }
                    CartApi.addOrEdit(item)
                }
            }

        }
        if (textError.length == 0) {
            this.setState({saving: true})
            CartApi.saveItems(() =>
                setTimeout(() => {
                    // CartApi.getItems()
                    this.props.hideScissors();
                }, 700)
            )

        } else {

            if (Object.keys(seriesErr).length == 0) {
                textError.push(
                    <Div className={current_theme == "dark" ? "yellow" : "red"}
                         style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                        <span>Заказ не будет поставлен в резерв! Продолжить?</span>
                    </Div>
                )
            } else {
                textError.push(
                    <Div className={current_theme == "dark" ? "yellow" : "red"}
                         style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                        <span>Заказ будет размещен без резерва на склад “под заказ” и с Вами свяжется менеджер! Продолжить?</span>
                    </Div>
                )
            }

            this.setState({error_text: textError})
            this.setActiveModal(constants.MODAL_SEND_ORDER)
        }
    }

    getOstQnt = (item) => {
        return (this.state.series.find((el) => {
            return item.seria.ost_id == el.ost_id
        }).ost_qnt * 1)
    }

    getSeriaQnt = (item) => {

        let total = 0

        this.state.items.map((el) => {

            if (item.seria.ost_id == el.seria.ost_id) {
                total += el.order_qnt * 1
            }
        })
        return total
    }

    render() {

        setTimeout(() => {
            this.noRender = false
            this.noRenderM2 = false
        }, 500)

        const width = this.getSafeWidth()
        const modals = <ModalRoot activeModal={this.state.activeModal}>

            <ModalPage hideCloseButton={true}
                       id={constants.MODAL_SEND_ORDER}
                       onClose={this.modalBack}
                       settlingHeight={100}
                       style={{
                           width: "100%"
                       }}
                       header={
                           <ModalPageHeader
                               after={<PanelHeaderButton
                                   onClick={this.modalBack}><Icon24Cancel/></PanelHeaderButton>}

                           >
                               Внимание!
                           </ModalPageHeader>
                       }
            >
                <Div>
                    <p>{this.state.error_text}</p>
                </Div>
                <Div style={{paddingBottom: '70px'}}>
                    <ButtonGroup mode="horizontal" stretched>
                        <Button before={<Icon24Done/>} size="l" stretched loading={this.state.saving}
                                onClick={() => this.addOrEditToCart(true)}>Да</Button>
                        <Button before={<Icon24Cancel/>} size="l" stretched
                                onClick={() => this.setActiveModal(null)}>Нет</Button>
                    </ButtonGroup>
                </Div>
            </ModalPage>
            <ModalPage hideCloseButton={true}
                       id={constants.MODAL_ADDITIONAL_PRODUCTS}
                       onClose={this.modalBack}
                       settlingHeight={100}
                       style={{
                           width: "100%"
                       }}
                       header={
                           <ModalPageHeader
                               after={<PanelHeaderButton
                                   onClick={this.modalBack}><Icon24Cancel/></PanelHeaderButton>}

                           >
                               Добавить услуги к товару {this.props.product.name}
                           </ModalPageHeader>
                       }>

                {this.state.items && this.state.current_index !== null ?
                    <AdditionalProducts product={this.props.product}
                                        current_item={this.state.items[this.state.current_index]}
                                        setAdditionals={this.setAdditionals}
                                        closeAdditionals={() => this.setActiveModal(null)}
                                        width={width}
                                        length={formatQnt(this.state.items[this.state.current_index].order_qnt / this.getSafeWidth())}/> : ''}


            </ModalPage>
        </ModalRoot>


        return (this.state.showSeries ?
                <Div>

                    <SplitLayout style={{marginBottom: "150px"}}>

                        <SplitCol>
                            {this.state.series.map((series_item, index) => (
                                <SplitLayout>
                                    <SplitCol className="bordered">
                                        <FormItem>
                                            {series_item.code ? series_item.code : 'Код серии не задан'}
                                        </FormItem>
                                    </SplitCol>
                                    <SplitCol className="bordered">
                                        <FormItem>
                                            {(series_item.ost_qnt * this.props.product.unit.K / this.props.current_unit.K).toFixed(3).toString().replace('.000', '')}
                                            <b>{this.props.current_unit.title}</b>
                                        </FormItem>
                                    </SplitCol>
                                </SplitLayout>))}
                        </SplitCol>

                    </SplitLayout>
                </Div> :
                [<SplitLayout style={{marginBottom: AdaptivityContext.isMobile ? "450px" : "150px"}} modal={modals}>
                    <SplitCol>
                        <SplitLayout>
                            <SplitCol>
                                <FormItem style={{textAlign: "right"}}>
                                    <Button size="l" stretched before={<Icon12CheckCircle/>}
                                            disabled={this.state.saving || this.props.current_user.tech_docs_blocked == '1'}
                                            loading={this.state.saving} onClick={() => {
                                        this.addOrEditToCart()
                                    }}>Подтвердить</Button>
                                </FormItem>

                            </SplitCol>
                        </SplitLayout>
                        {this.props.oneSeriaDisabled ? '' : <SplitLayout>
                            <SplitCol>
                                <SimpleCell Component="label" after={<Switch onChange={(e) => this.changeOneSeria(e)}
                                                                             checked={this.state.one_seria}/>}>
                                    Одна серия
                                </SimpleCell>
                            </SplitCol>
                        </SplitLayout>}
                        {this.state.series.length > 0 ? <SplitLayout>
                            <SplitCol>
                                <FormItem>
                                    Макс.
                                    отрез {formatQnt(this.getMaxSeriesScissors(this.state.series).ost_qnt / this.getSafeWidth())} пог.м
                                </FormItem>

                            </SplitCol>
                            <SplitCol>
                                <FormItem style={{textAlign: "right"}}>
                                    <Button onClick={() => {
                                        this.setState({showSeries: true});
                                        this.props.setShowScissorsSeries()
                                    }}>Серии</Button>
                                </FormItem>

                            </SplitCol>
                        </SplitLayout> : ''},
                        <List>
                            {this.state.items.map((item, index) => (
                                [<SplitLayout>
                                    <SplitCol>
                                        <FormItem>
                                            {`Отрез ${index + 1}`}
                                            <SimpleCell
                                                after={

                                                    item.seria ? ((this.getOstQnt(item) >= item.order_qnt ? 'Макс. отрез: ' : 'Не хватает: ') + formatQnt((this.getOstQnt(item) - item.order_qnt) / this.getSafeWidth()) + ' пог.м') : ''
                                                }
                                            >
                                                <Chip
                                                    removable={false}>Серия: {item.seria ? item.seria.code : 'Нет'}</Chip>
                                            </SimpleCell>

                                        </FormItem>
                                    </SplitCol>
                                </SplitLayout>,
                                    <SplitLayout>
                                        <SplitCol>
                                            <FormItem top="Пог.м">
                                                <Input type="text"
                                                       placeholder={this.state.width.value * 1 ? "Количество" : "Недоступно"}
                                                       autoFocus readOnly={!this.state.width.value * 1}
                                                       onChange={(e) => this.changeOrder(e, index, false)}
                                                       value={item.order_qnt && this.state.width.value * 1 ? (this.noRender ? item.order_qnt_M : formatQnt(item.order_qnt / this.getSafeWidth())) : (item.order_qnt === 0 && this.state.width.value * 1 ? 0 : '')}/>
                                            </FormItem>
                                        </SplitCol>
                                        <SplitCol>
                                            <FormItem top="Кв.м">
                                                <Input type="text" placeholder="Количество"
                                                       onChange={(e) => this.changeOrder(e, index, true)}
                                                       value={item.order_qnt ? (this.noRenderM2 ? item.order_qnt : formatQnt(item.order_qnt * 1)) : (item.order_qnt === 0 ? 0 : '')}/>
                                            </FormItem>
                                        </SplitCol>
                                    </SplitLayout>,
                                    <SplitLayout>
                                        <SplitCol>
                                            {this.state.items && this.state.items.length < 5 && index == this.state.items.length - 1 &&
                                                <FormItem>
                                                    <Button
                                                        mode="primary" stretched size="m" onClick={() => {
                                                        this.addPiece()
                                                    }}>+ еще отрез</Button>
                                                </FormItem>}
                                        </SplitCol>
                                        <SplitCol>
                                            <FormItem>
                                                <Button mode="primary" stretched size="m"
                                                        disabled={!(item.order_qnt && this.state.width.value * 1)}
                                                        onClick={() => this.showAdditionals(index)}>Услуги</Button>
                                            </FormItem>
                                        </SplitCol>
                                    </SplitLayout>, item.additionalItems && item.additionalItems.length > 0 &&
                                <SplitLayout>
                                    <SplitCol>

                                        <Div className="scissors-additionals-products"><Header mode="primary">Услуги в
                                            заказе:</Header>
                                            {item.additionalItems.map(el =>
                                                ((el.need_ost && el.qnt * 1 > 0) || el.checked) ? <SimpleCell
                                                    after={el.need_ost ? el.qnt + 'м' : ''}>{el.name}</SimpleCell> : '')
                                            }
                                        </Div>
                                    </SplitCol>
                                </SplitLayout>,
                                    index === this.state.items.length - 1 && <SplitLayout
                                        style={{marginBottom: index === this.state.items.length - 1 ? '150px' : "inherit"}}>
                                        <SplitCol>

                                        </SplitCol>
                                    </SplitLayout>]
                            ))}

                        </List>
                    </SplitCol>
                </SplitLayout>,
                    <hr/>]
        )
    }

    changeOneSeria = (e) => {
        this.setState({one_seria: e.target.checked});
        setTimeout(() => {
            this.changeOrder()
        }, 600)
    }

    getSafeWidth = () => {
        return this.state.width && this.state.width.value * 1 > 0 ? this.state.width.value * 1 : 1
    }

    showAdditionals = (index) => {
        this.setState({current_index: index})
        this.setActiveModal(constants.MODAL_ADDITIONAL_PRODUCTS)
    }
}

export default Scissors